import type {
  FreeDropinRewardPreviewRequest,
  FreeDropinRewardPreviewResponse
} from '../../../pure-js/types/QueryParamTypes'
import { getFreeDropinRewardPreview } from './CloudFunctionsApiHandler'

export type FreeDropinRewardPreviewLoader = (
  request: FreeDropinRewardPreviewRequest
) => Promise<FreeDropinRewardPreviewResponse>

export const loadFreeDropinRewardPreview: FreeDropinRewardPreviewLoader = getFreeDropinRewardPreview

export {
  FreeDropinPreviewUserRole,
  type FreeDropinRewardPreviewRequest,
  type FreeDropinRewardPreviewResponse,
  type FreeDropinRewardPreviewUserRequest,
  type FreeDropinRewardPreviewUserResponse
} from '../../../pure-js/types/QueryParamTypes'
